import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CButton,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormSelect,
  CFormInput,
  CModal,
  CModalBody,
} from "@coreui/react";
import { fetchUserKycList } from "../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirst } from "../../utils/stringUtils";
import { timeAgo } from "../../utils/timeAgo";
import AppLoader from "../../components/seller/AppLoader";
import AppMessage from "../../components/seller/AppMessage";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../config/environment";

const UploadKyc = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { kycList, kycLoading } = useSelector((state) => state.user);
  const user = useSelector((state) => state.auth.user);
  console.log("Kyc user:", user);

  const [visible, setVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  console.log("Kyc list:", kycList);

  //   useEffect(() => {
  //   const kycApproved = user?.kyc_verified === 1;
  //   const certApproved = user?.certification_verified === 1;

  //   if (kycApproved && !certApproved) {
  //     navigate("/seller/certificate");
  //   }
  // }, [user, navigate]);

  useEffect(() => {
    dispatch(fetchUserKycList()).then((res) => {
      const kycStatus = user?.kyc_verified;
      // console.log("Kyc status:", kycStatus);

      // If user is not KYC approved and the list is empty
      if (kycStatus !== 1 && res.payload.length === 0) {
      }
    });
  }, [dispatch]);

  // const handleView = (fileUrl) => {
  //   setSelectedImage(fileUrl);
  //   setVisible(true);
  // };

  const filtered = kycList.filter((item) =>
    item.document_type.toLowerCase().includes(search.toLowerCase())
  );

  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / entriesPerPage);

  if (kycLoading) return <AppLoader />;

  return (
    <div className="container-fluid px-3">
      <CRow>
        <CCol>
          <h4 className="mb-3">Verification Status Overview</h4>
        </CCol>
        <CCol className="text-end">
          <CButton
            color="primary"
            className="me-2"
            onClick={() => {
              // console.log("Navigating to upload KYC form");
              navigate("/seller/upload-kyc-form");
            }}
          >
            Verify Profile
          </CButton>
          <CButton color="secondary" onClick={() => navigate(-1)}>
            Back
          </CButton>
        </CCol>
      </CRow>

      {user?.kyc_verified === 0 && (
        <AppMessage
          title="Action Required"
          message="Your profile verification is still pending. Please upload the required documents."
          style={{ marginTop: "20px" }}
        />
      )}

      <CCard className="mt-3">
        <CCardHeader>
          <CRow className="align-items-center">
            <CCol md={6}>
              Show{" "}
              <CFormSelect
                size="sm"
                value={entriesPerPage}
                onChange={(e) => {
                  setEntriesPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{ display: "inline-block", width: "auto" }}
                options={[
                  { label: "5", value: "5" },
                  { label: "10", value: "10" },
                  { label: "25", value: "25" },
                ]}
              />{" "}
              entries
            </CCol>
            <CCol md={6} className="text-end">
              Search:{" "}
              <CFormInput
                type="text"
                size="sm"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ display: "inline-block", width: "200px" }}
              />
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CTable responsive bordered hover>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell>#</CTableHeaderCell>
                <CTableHeaderCell>Verification Type</CTableHeaderCell>
                <CTableHeaderCell>Document Type</CTableHeaderCell>
                <CTableHeaderCell>Uploaded File</CTableHeaderCell>
                <CTableHeaderCell>Verification Status</CTableHeaderCell>
                <CTableHeaderCell>Uploaded At</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {currentData.map((doc, index) => (
                <CTableRow key={doc.id}>
                  <CTableDataCell>{indexOfFirst + index + 1}</CTableDataCell>
                  <CTableDataCell>
                    {doc.kyc_type ? capitalizeFirst(doc.kyc_type) : "-"}
                  </CTableDataCell>
                  <CTableDataCell>{doc.document_type || "-"}</CTableDataCell>
                  <CTableDataCell>
                    {doc.document_path ? (
                      <CButton
                        size="sm"
                        color="info"
                        onClick={() =>
                          window.open(
                            `https://pixadb.com/storage/${doc.document_path}`,
                            "_blank"
                          )
                        }
                      >
                        View
                      </CButton>
                    ) : (
                      "-"
                    )}
                  </CTableDataCell>
                  <CTableDataCell>
                    <span
                      className={`badge bg-${doc.status === "approved" ? "success" : "warning"
                        }`}
                    >
                      {doc.status ? capitalizeFirst(doc.status) : "-"}
                    </span>
                  </CTableDataCell>
                  <CTableDataCell>
                    {doc.created_at ? timeAgo(doc.created_at) : "-"}
                  </CTableDataCell>
                </CTableRow>
              ))}
              {currentData.length === 0 && (
                <CTableRow>
                  <CTableDataCell
                    colSpan="6"
                    className="text-center text-muted"
                  >
                    No records found.
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>

          {/* Pagination Controls */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing {indexOfFirst + 1} to{" "}
              {Math.min(indexOfLast, filtered.length)} of {filtered.length}{" "}
              entries
            </div>
            <div className="d-flex align-items-center">
              <CButton
                size="sm"
                color="light"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                className="me-2"
              >
                Prev
              </CButton>

              {[...Array(totalPages)].map((_, i) => (
                <CButton
                  key={i}
                  size="sm"
                  color={currentPage === i + 1 ? "primary" : "light"}
                  onClick={() => setCurrentPage(i + 1)}
                  className="me-2"
                >
                  {i + 1}
                </CButton>
              ))}

              <CButton
                size="sm"
                color="light"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>

      {/* Image Modal */}
      <CModal visible={visible} onClose={() => setVisible(false)} size="lg">
        <CModalBody>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="KYC Document"
              style={{ width: "100%", height: "auto" }}
            />
          )}
        </CModalBody>
      </CModal>
    </div>
  );
};

export default UploadKyc;
